import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { TimelineMax, Tween, TweenLite} from "gsap";
import { IDimConfig, ResizeHelper, LayoutDimData } from"@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Point } from "pixi.js";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SanGameConfig} from "../../../SanGameConfig"
import { BLEND_MODES } from "pixi.js";

import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { JumpingWildController ,WildItem} from "../jumpingWild/JumpingWildController";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { SpinePlayer } from "../../../proto/SpinePlayer";
import { SanJumpData } from "../../../server/data/ISanServerData";

export class JumpingWildCollector extends BaseView {

    private _disable_seq:Sequence[] = [];
    private _active_seq:Sequence[]= [];

    private _upgrade_spines:SpinePlayer[]= [];

    private _indicators:Sequence[]= [];
    private _towerIndicators:PIXI.Sprite[] = [];

    private _showing:boolean = true;

    private amountOfItems:number = 3;

    private _timeLine:TimelineMax;

    private _isFS:boolean = false;

    private objDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 0.7, 0.7),
                position:   new Point( 700, 400),
                // position:   new Point( 800, 2),
                layout :{
                    left:   new Point( 700, 400),
                    right:  new Point( 700, 400)
                }
            },
            portrait :{
                scale:      new Point( 0.6, 0.6),
                position:   new Point( 550, -160)
            }
        },
        WIDTH: 900,
        HEIGHT: 540,
    };
    
    private explodeTexture:PIXI.Texture[];
    private activeTexture:PIXI.Texture[];

    public get showing():boolean{ return this._showing };

    private static _instance:JumpingWildCollector;
    public static get instance():JumpingWildCollector{
        return this._instance;
    }

    constructor() {
        super();
        JumpingWildCollector._instance = this;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FEATURE.name).addChild(this);
    }

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.objDim); };


    public restoreReActive(amount:number):void{

        for (let i = 0; i < amount; i++) {
            const element = this._active_seq[i];
            element.setTexture(this.explodeTexture);
            element.scale.set(2,2);     
            const item:WildItem =  JumpingWildController.instance.createJumpWild(i+1,1,0);
            item.updatePos = () => Helper.copyLocalPosition(item.cont,element);
            item.updateScale = () => <PIXI.Point>this.scale;

            element.playAnimation({
                onStart:() => {
                    element.alpha = 1;
                },
                onCompleteCallback:() => {
                    element.setTexture(this.activeTexture)
                    element.scale.set(1,1);
                }
            });
        }
    }

    public setActiveJumpingWilds(pos:number,reelpos:number,sympos:number):TimelineMax{
        
        this._active_seq[pos].setTexture(this.explodeTexture);
        this._active_seq[pos].scale.set(2,2);

        const item:WildItem =  JumpingWildController.instance.createJumpWild(reelpos,sympos,0);
        item.updatePos = () => Helper.copyLocalPosition(item.cont,this._active_seq[pos]);
        item.updateScale = () => <PIXI.Point>this.scale;

        return this._active_seq[pos].playAnimation({
            onStart:() => {
                this._active_seq[pos].alpha = 1;
            },
            onCompleteCallback:() => {
                this._active_seq[pos].setTexture(this.activeTexture)
                this._active_seq[pos].scale.set(1,1);
            }
        });
    }

    public Restore():void{
        this._towerIndicators.forEach(s => TweenLite.to(s,0.5,{alpha:0}));
        this._upgrade_spines.forEach(s => TweenLite.to(s,0.5,{alpha:0}).eventCallback("onComplete",() => {s.stop(); s.alpha = 1}));
        this._indicators.forEach(i => TweenLite.to(i,0.5,{alpha:0}).eventCallback("onComplete",() => i.stop(true)));
        this._disable_seq.forEach(s => TweenLite.to(s,0.5,{alpha:0}));

        this._showing = true;
    }

    public popToPos(jData:SanJumpData[]):void{
        for(let i:number = 0; i <  JumpingWildController.instance.items.length;i++){
            JumpingWildController.instance.items[i].ReelID = jData[i].to.reel
            JumpingWildController.instance.items[i].SymID = jData[i].to.row;
        }
    }

    public popJumpingWilds():TimelineMax{
        this._showing = false;
        this._active_seq.forEach(s => s.alpha = 0);

        JumpingWildController.instance.items.forEach(j => j.cont.visible = true);
        JumpingWildController.instance.forceResize();

        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax());
        this._timeLine.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_JUMPINGWILD_IN),0);
        for(let i:number = 0; i <  JumpingWildController.instance.items.length;i++){
            this._timeLine.add([
                JumpingWildController.instance.JumpTo({ID:i, to:{reel:JumpingWildController.instance.items[i].ReelID,row:JumpingWildController.instance.items[i].SymID},duration:0.5},true,true),
                TweenLite.fromTo(JumpingWildController.instance.items[i].cont.scale,0.5,{x:this.scale.x,y:this.scale.y},{x:SanEngineManager.dim.scale.x,y:SanEngineManager.dim.scale.y})
            ],0)
        }

        this._timeLine.add(() => {
            this._upgrade_spines.forEach(s => TweenLite.to(s,0.5,{alpha:0}).eventCallback("onComplete",() => {s.stop(); s.alpha = 1}));
            this._disable_seq.forEach(s => TweenLite.to(s,0.5,{alpha:0}));
            this._indicators.forEach(i => TweenLite.to(i,0.5,{alpha:0}).eventCallback("onComplete",() => i.stop(true)));
            this._towerIndicators.forEach(s => TweenLite.to(s,0.5,{alpha:0}));
        },0);
        return this._timeLine;
    }

    public changeModePos(mode:boolean):TweenLite[]{
        this._isFS = mode;
        const arra:TweenLite[] = [];

        if(this._isFS && ResizeHelper.IsLandscape()){
            this._active_seq.forEach(s => TweenLite.to(s.position,2.5,{y:"-=210",delay:0.75}));
            this._towerIndicators.forEach(s => TweenLite.to(s.position,2.5,{y:"-=210",delay:0.75}));
            this._upgrade_spines.forEach(s => TweenLite.to(s.position,2.5,{y:"-=210",delay:0.75}));
            this._disable_seq.forEach(s => TweenLite.to(s.position,2.5,{y:"-=210",delay:0.75}));
            this._indicators.forEach(s => TweenLite.to(s.position,2.5,{y:"-=210",delay:0.75}));
        }else if(!this._isFS){
            this.onResize();

            // this._active_seq.forEach(s => TweenLite.to(s.position,3,{y:"-=210",delay:0.75}));
            // this._towerIndicators.forEach(s => TweenLite.to(s.position,3,{y:"-=210",delay:0.75}));
            // this._upgrade_spines.forEach(s => TweenLite.to(s.position,3,{y:"-=210",delay:0.75}));
            // this._disable_seq.forEach(s => TweenLite.to(s.position,3,{y:"-=210",delay:0.75}));
            // this._indicators.forEach(s => TweenLite.to(s.position,3,{y:"-=210",delay:0.75}));

        }
        return arra;
    }
    
    // public individualToShow(ID:number):PIXI.DisplayObject{
    //     const item: WildItem = this.getExistingItem(ID)!;
    //     if(item.multValue > 1){
    //         item.spine.play({name:"X" + item.multValue + "_Idle",loop:true})
    //         return item.spine;
    //     }else{
    //         return item.seq;
    //     }
    // }

    // public individualToShow(ID:number):PIXI.DisplayObject{
    //     item.spine.play({name:"X"+item.multValue}).eventCallback("onComplete",() => item.spine.play({name:"X" + item.multValue + "_Idle",loop:true}));
    //     const item: WildItem = this.getExistingItem(ID)!;
    //     if(item.multValue > 1){
    //         item.spine.play({name:"X" + item.multValue + "_Idle",loop:true})
    //         return item.spine;
    //     }else{
    //         return item.seq;
    //     }
    // }
    
    public indicatorState(ammLanded:number):void{
        for(let i:number = 0; i < ammLanded;i++){
            this._indicators[i].playAnimation({onStart:()=>{this._indicators[i].alpha = 1}, repeat:-1});
        }
        if(ammLanded == 0)
            this._indicators.forEach(i => TweenLite.to(i,0.5,{alpha:0}).eventCallback("onComplete",() => i.stop(true)));
    }

    public reset():void{
        this._showing = true;
        this._disable_seq.forEach(s => TweenLite.to(s,0.5,{alpha:0.75}));
        this._indicators.forEach(i => TweenLite.to(i,0.5,{alpha:0}).eventCallback("onComplete",() => i.stop(true)));
        this._towerIndicators.forEach(s => TweenLite.to(s,0.5,{alpha:1}));
    }

    private createSpines():void{
        if(this._upgrade_spines.length == 0){
            for(let i:number= 0; i < this.amountOfItems; i++){
                this._upgrade_spines.push(this.addChild(new SpinePlayer("JW_Multi")));
                this._upgrade_spines[i].position = this._active_seq[i].position;
                this._upgrade_spines[i].zIndex = 80;
            }
            this.sortChildren();
        }
    }

    public upgradeJWRestore(amm:number,id:number):void{
        this.createSpines();

        this._upgrade_spines[id].play({name:"X"+amm}).eventCallback("onComplete", () => this._upgrade_spines[id].play({name:"X"+amm+"_Idle",loop:true}));
        JumpingWildController.instance.changeMult(id,amm);
    }

    public upgradeJW(amm:number):void{
       
        this.createSpines();

        for(let i:number= 0; i < this._active_seq.length; i++){
            if(this._active_seq[i].alpha > 0){
                this._upgrade_spines[i].play({name:"X"+amm}).eventCallback("onComplete", () => this._upgrade_spines[i].play({name:"X"+amm+"_Idle",loop:true}));
                JumpingWildController.instance.changeMult(i,amm);
            }
        }
    }

    protected initAnimations():void{

        this.activeTexture = GameResources.getTextures("Jumping_Wild/JW_4_Badge");
        this.explodeTexture = GameResources.getTextures("JW_Reveal");

        for(let i:number= 0; i < this.amountOfItems; i++){
            this._disable_seq.push(this.addChild(Sequence.createSequence(GameResources.getTextures("Jumping_Wild/JW_4_Badge_Dead"))));
            this._active_seq.push(this.addChild(Sequence.createSequence(GameResources.getTextures("Jumping_Wild/JW_4_Badge"))));
            this._disable_seq[i].alpha = 0.75;
        }

        for(let i:number= 0; i < 5; i++){
            this._towerIndicators.push(this.addChild(new PIXI.Sprite(GameResources.getTextures("JW_Indicator")[0])));
            this._towerIndicators[i].anchor.set(.5,.5);
            this._towerIndicators[i].zIndex = 90;
            this._indicators.push(this.addChild(Sequence.createSequence(GameResources.getTextures("JW_Indicator_Light"))));
            this._indicators[i].blendMode = BLEND_MODES.ADD;
            this._indicators[i].alpha = 0;
            this._indicators[i].zIndex = 100;
        }
    }

    public onResize():void{

        const isLand:boolean = ResizeHelper.IsLandscape();


        const isFsPosY:number = isLand && this._isFS ? -140 : 70;

        for(let i:number = 0; i < this.amountOfItems; i++){
            const xPos:number =  isLand ? 10 : 90 * i;
            const yPos:number =  !isLand ? 0 : isFsPosY + (180 * i)*this.dim.scale.y;
            this._active_seq[i].zIndex = isLand ? i : (this.amountOfItems-1) - i;
            this._disable_seq[i].zIndex = isLand ? i : (this.amountOfItems-1) - i;

            this._disable_seq[i].position.set(xPos,yPos);
            this._active_seq[i].position.set(xPos,yPos);

            if(this._upgrade_spines.length > 0){
                this._upgrade_spines[i].position = this._active_seq[i].position;
            }

            const yOffset:number = yPos-50;

            if(i == 0){
                this._towerIndicators[0].position.set(xPos-40,yOffset);
                this._towerIndicators[1].position.set(xPos ,yOffset);
                this._towerIndicators[2].position.set(xPos+40,yOffset);

                this._indicators[0].position.set(xPos-40,yOffset);
                this._indicators[1].position.set(xPos ,yOffset);
                this._indicators[2].position.set(xPos+40,yOffset);
            }
            else if(i == 1){
                this._towerIndicators[3].position.set(xPos,yOffset);
                this._indicators[3].position.set(xPos,yOffset);
            }
            else{
                this._towerIndicators[4].position.set(xPos,yOffset);
                this._indicators[4].position.set(xPos,yOffset);
            }
        }

        this.sortChildren();

        this.position = this.dim.position;
        this.scale = this.dim.scale;
    }
}